import axios from 'axios';
import qs from 'qs';
import md5 from 'md5';
import Config from './util/config'; 

const request = (url = 'https://api.giftcard8.com', type = 'POST', data = {}, header = { 'Content-Type': 'application/x-www-form-urlencoded' }) => {
  return new Promise((resolve, reject) => {
    
    const token = localStorage.getItem('giftcard8_token');

    const safeData = data && typeof data === 'object' ? data : { };

    const requestData = {
      appid: Config.appId,
      token: token || '',
      sign: md5(
        qs.stringify({
          appid: Config.appId,
          token: token || '',
          ...safeData, 
        }, { arrayFormat: 'indices', encode: false }) + Config.appKey
      ),
      ...safeData, 

    };

    console.log(requestData);
    

    axios({
      method: type,
      url: url,
      headers: header,
      data: type.toLowerCase() === 'get' ? undefined : requestData,  
      params: type.toLowerCase() === 'get' ? requestData : undefined, 
    })
      .then((res) => {
        if (res.data && res.data.msg) {
          if (res.data.msg === 'Token is no longer valid, please log in again') {
            localStorage.removeItem('giftcard8_token_token');
            localStorage.removeItem('giftcard8_token_user_info');
          } else if (res.data.msg === 'Necessary parameter error:token') {
            localStorage.removeItem('giftcard8_token');
            localStorage.removeItem('giftcard8_token_user_info');
          }
        }
        resolve(res.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default request;
